export function cleanForFirestore<T>(value: T): T {
  if (Array.isArray(value)) return value.map(cleanForFirestore) as T;
  if (value instanceof Date || value === null || typeof value !== "object") return value;
  const prototype = Object.getPrototypeOf(value);
  // Preserve Firestore sentinels, timestamps, references, and other SDK values.
  if (prototype !== Object.prototype && prototype !== null) return value;
  return Object.fromEntries(Object.entries(value as Record<string, unknown>).filter(([, item]) => item !== undefined).map(([key, item]) => [key, cleanForFirestore(item)])) as T;
}

export function withoutId<T extends { id: string }>(value: T): Omit<T, "id"> {
  const { id: _id, ...document } = value;
  return cleanForFirestore(document);
}
